import styled from "styled-components";

import { useUserData } from "Flocknote/apiHooks";

import FnrNetworkPhoto from "UI/FnrNetworkPhoto";

const LeftSection = () => {
  const [{ photoUrl }] = useUserData();

  return (
    <PhotoAndEditWrapper>
      <FnrNetworkPhoto
        size="decorative1"
        src={photoUrl}
        color="grey"
        shape="square"
      />
    </PhotoAndEditWrapper>
  );
};

const PhotoAndEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export default LeftSection;
